package com.partejar.app.core.di

import org.koin.core.module.Module
import org.koin.dsl.module

actual fun platformStorageModule(): Module = module { }
